import { type FunctionalComponent, h } from '@stencil/core';
import type { IResultList } from '../types/subcomponents-types.type';
import { ResultsSorting } from '../result-sorting/results-sorting';
import { sortingOptions } from '../../../../../constants/sortingConstants';
import { SearchResultTag } from '../search-result-tag/search-result-tag';
import type { SearchProduct } from '../../../../../api/SearchApi';

export const ViewResultList: FunctionalComponent<IResultList> = (props) => {
    const totalResults = props.queryResult.documents.length;
    const secondResultPosition = 0;
    const firstPositionFoGrid = 0;
    const halfResults = Math.floor(totalResults / 2);
    const ontThirds = Math.floor(totalResults / 3);
    const twoThirds = ontThirds * 2;

    const resultListBody = (rtl: boolean) => (
      <div class="results-container">
        {props.productCatalogWidget ? (
          <uiaas-search-widget-product-catalog
            labelProvider={(e, f) => props.labelProvider(e, f)}
          />
        ) : (
          ''
        )}

        {props.gridView ? '' : <slot name={'before-first-result'}/>}
        {props.gridView && props.aggregatedResults.length <= 2
          ? offsiteWidgetV2(props.gridView)
          : ''}
        {props.aggregatedResults.map((doc, index) => {
            const itemsAmount = props.aggregatedResults?.length;

            return [
              <div class={{ 'se-block-grid': props.gridView, 'result-card__wrapper': true }}>
                <SearchResultTag
                  doc={doc as unknown as SearchProduct}
                  index={index + props.resultIndexOffset}
                  resultRenderer={props.resultRenderer}
                  labelProvider={(e, f) => props.labelProvider(e, f)}
                  country={props.country}
                  language={props.language}
                  gridView={props.gridView}
                  isEcommerceMode={props.isEcommerceMode}
                  eShop={props.eShop}
                  rtl={rtl}
                  strategies={props.strategies}
                  resultClickAnalytics={props.resultClickAnalytics}
                  isSubstitutionTool={props.isSubstitutionTool}
                  eolProductsNumber={props.resultIndexOffset}
                  wcEventData={props.wcEventData}
                  isUnifiedCheckout={props.isUnifiedCheckout}
                  marketingProductBadgesFilters={props.marketingProductBadgesFilters}
                />
              </div>,
              props.gridView && props.aggregatedResults.length > 2 && index === 2 ? productRecommendationWidgetSlot() : '',
              !props.gridView && index === 0 ? productRecommendationWidgetSlot() : '',
              <slot name={'after-' + index + '-result'} />,
              (secondResultPosition == index && !props.gridView) ||
              (props.gridView &&
                props.aggregatedResults.length > 2 &&
                index == firstPositionFoGrid)
                ? offsiteWidgetV2(props.gridView)
                : '',
              halfResults == index ? <slot name="mid-results" /> : '',
              ontThirds == index ? <slot name="one-third-results" /> : '',
              twoThirds == index ? <slot name="two-thirds-results" /> : '',
            ];
        })}
        {props.gridView && props.aggregatedResults.length < 3 ? productRecommendationWidgetSlot() : ''}
        <slot name="after-all-results" />
        <div class={'search-tab__results-sorting-container'}>
          <ResultsSorting
            sortingOptions={props.queryResult.sortOptions}
            defaultValueId={props.sortOption?.id || sortingOptions.RELEVANCY}
            enableSorting={
              props.sortingResults && !props.reflectedState.ajaxIsLoading
            }
            labelProvider={(e, f) => props.labelProvider(e, f)}
            scrollToTop={props.scrollToTop}
          />
        </div>
      </div>
    );

    const gridWrapper = (child: CallableFunction, rtl: boolean) => {
        return (
          <se-container
            display="grid"
            padding="none"
            column-size="280px"
            color="none"
            class="grid-container"
            id="grid-container"
          >
            {child(rtl)}
          </se-container>
        );
    };

    if (!props.gridView) return resultListBody(props.rtl);
    if (props.gridView) return gridWrapper(resultListBody, props.rtl);
};

const offsiteWidgetV2 = (isGridView: boolean) => (
  <div class={{ 'offsite-widget-v2-grid': isGridView }}>
    <slot name={'before-first-result'} />
  </div>
);

const productRecommendationWidgetSlot = () => (
  <slot name='prodcut-recommendation-widget' />
);
